import {Sponsorship} from '../generated/graphql';
import {Perspective} from '../types/Event';

export const isPerspectiveSponsorship = (
  eventSponsorship?: Sponsorship | null,
  perspective?: Perspective,
) => {
  return !eventSponsorship && perspective?.sponsorship;
};
